import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled, withStyle } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledBaseButton = styled("button", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  width: $theme.space[32],
  aspectRatio: 1,
  borderRadius: "50%",
  color: $theme.colors["text-brand-primary"],
  cursor: "pointer",
  fontSize: $theme.fontSizes[14],
  justifyContent: "center",
  userSelect: "none",
  backgroundColor: "transparent",
  borderWidth: 0,
  borderColor: $theme.colors["borders-brand-primary"],
  borderStyle: "solid",
  lineHeight: 1,
  ":disabled": {
    color: $theme.colors["text-global-disabled"],
    cursor: "default"
  },
  ":focus-visible": $theme.focusOutline
}));
const StyledList = styled("ul", ({ $theme }) => ({
  display: "flex",
  listStyle: "none",
  margin: 0,
  padding: 0,
  gap: $theme.space[8]
}));
const StyledListItem = styled("li", {});
const StyledItemButton = withStyle(StyledBaseButton, ({ $theme, $isCurrrent }) => __spreadValues({
  ":hover": {
    borderWidth: "5px"
  },
  ":active": {
    background: $theme.colors["background-brand-primary-light"],
    color: $theme.colors["text-global-inverse"],
    borderWidth: 0
  }
}, $isCurrrent && {
  borderWidth: "2px"
}));
const StyledStepperButton = withStyle(StyledBaseButton, () => ({
  ":disabled": {
    visibility: "hidden"
  }
}));
const StyledRoot = styled("nav", ({ $theme }) => ({
  display: "flex",
  gap: $theme.space[8]
}));

export { StyledItemButton, StyledList, StyledListItem, StyledRoot, StyledStepperButton };
